import Raven from '../Raven'
import { createCustomerToken, getCustomerToken } from '../../components/utils/Customer'
import { getCountryCode3 } from '@GlobalHelpers'
import { last } from 'lodash'

/** Get order currency from API.
 * @param {string} periodStart market as a country code (e.g. SG, AU, NZ).
 * @param {string} periodEnd ship to country code (e.g. SG, AU, NZ).
 * @param {string} href order invoice id.
 * @param {string} token order invoice id.
 */
export const getOrderHistoryList = (baId, hydraToken, isBypassCache = false, leadMoreOrder) => {
    // const params = {
    //     expand: 'orderHistory',
    //     expandOrderHistory: 'order,rma',
    //     dateCreated: `[${periodStart}|${periodEnd}]`,
    //     customer: 'me|sponsoredCustomers?type=Customer',
    //     customerHref: href
    // }
    const isDummy = localStorage.getItem('isDummy')
    const params = {
        baId: baId,
        ushopCountryCode: getCountryCode3().toUpperCase(),
        ...(isDummy ? { isDummy } : {})
    }

    if (isBypassCache) {
        params.byPassCache = '1'
    }

    if (localStorage.getItem('dummy-user')) {
        params.isMockup = 1
    }

    const configs = {
        headers: {
            'Content-Type': 'application/json',
            'authorization-hydra': `Bearer ${hydraToken}`,
            'authorization-ushop': 'Bearer tVxbmKcjme'
        }
    }

    const BASE_ORTER_HISTORY_URL = 'https://member-calls2.unicity.com/etlV2/ordersHistory'
    let ORTER_HISTORY_URL = BASE_ORTER_HISTORY_URL

    if (leadMoreOrder) {
        const { yearsStart, yearsEnd, monthStart, monthEnd, country = 'THA' } = leadMoreOrder
        const DEFINE_ORTER_HISTORY_URL = `${BASE_ORTER_HISTORY_URL}?ushopCountryCode=${country}&baId=${baId}&periodStart=${yearsStart}-${monthStart}&periodEnd=${yearsEnd}-${monthEnd}`
        ORTER_HISTORY_URL = DEFINE_ORTER_HISTORY_URL
    }
    
    return Raven.get(ORTER_HISTORY_URL, params, configs).catch(async err => {
        console.error('leadMoreOrder config is invalid:', err)
       return await Raven.get(BASE_ORTER_HISTORY_URL, params, configs)
    })
}

/** Get order currency from API.
 * @param {string} market market as a country code (e.g. SG, AU, NZ).
 * @param {string} shipToCountry ship to country code (e.g. SG, AU, NZ).
 * @param {string} orderId order invoice id.
 */
export const getOrderHistoryCurrency = (market, shipToCountry, orderId) => {
    const data = {
        market: market,
        shipToCountry: shipToCountry,
        orderId: orderId
    }

    const configs = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    }

    return Raven.post('https://tkvjrct9we.execute-api.ap-southeast-1.amazonaws.com/production', data, configs)
}

export const getOrderHistoryDetails = (token, orderUrl, country) => {
    let ref = last(orderUrl.split('/'))

    const isDummy = localStorage.getItem('isDummy')
    const data = {
        orderRef: ref,
        ushopCountryCode: country,
        ...(isDummy ? { isDummy } : {})
    }

    if (localStorage.getItem('dummy-user')) {
        data.isMockup = 1
    }

    return Raven.get('https://member-calls2.unicity.com/etlV2/orderDetail', data, {
        headers: {
            'authorization-hydra': token
        }
    })
}

export const getOrderHistoryByBAID = baID => {
    const params = {
        baId: baID
    }

    if (localStorage.getItem('dummy-user')) {
        params.isMockup = 1
    }

    const configs = {
        headers: {
            'Content-Type': 'application/json',
            'authorization-hydra': `Bearer ${getCustomerToken()}`,
            'authorization-ushop': 'Bearer tVxbmKcjme'
        }
    }

    return Raven.get('adapter/etl/genealogy', params, configs)
}

const create = (baId, now = new Date()) => {
    const date = now.getUTCDate()
    const weekDay = now.getUTCDay() + 1
    const modeWeekDay = (date % weekDay) + 1
    const hash = baId
        .toString()
        .split('')
        .map(c => parseInt(c) % modeWeekDay)
        .join('')
    return `${hash}${weekDay}${date}`
}
